module.exports = __webpack_public_path__ + "static/media/attendedEmpty.ac0a35f6.svg";